import { usePrefersReducedMotion } from "~/lib/hooks/usePrefersReducedMotion";

export const useScrollToTop = () => {
	const isBrowser = () => typeof window !== "undefined";
	const prefersReducedMotion = usePrefersReducedMotion();

	const scrollToTop = () => {
		if (!isBrowser()) return;
		window.scrollTo({
			top: 0,
			behavior: prefersReducedMotion ? "auto" : "smooth",
		});
	};
	return scrollToTop;
};
